import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddAssignCourse = () => {
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    phone: "",
    // roll_no: "",
    address: "",
    gender: "",
    // admission_Date: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedTutor, setSelectedTutor] = useState("");
  const [tutors, setTutors] = useState([]);
  const [token, setToken] = useState("");
  const [courseCategories, setCourseCategories] = useState([]);
  //   const [courseCategories, setCourseCategories] = useState("");
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  useEffect(() => {
    // const token1 = localStorage.getItem("token");
    const token1 = localStorage.getItem("token");
    setToken(token1);
    if (!token1) {
      // console.log("Access required");
      return;
    }
    fetchdepartment();
    fetchAllCourses();
  }, []);

  useEffect(() => {
    fetchCourseCategories();
    fetchTutors();
    fetchCoursesByDepartment();
  }, [selectedDepartment, selectedCourseCategory]);

  const fetchCoursesByDepartment = async () => {
    if (!selectedDepartment) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses/${selectedDepartment}/${selectedCourseCategory}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCourses(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchCourseCategories = async () => {
    if (!selectedDepartment) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${selectedDepartment}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCourseCategories(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchAllCourses = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Course-nopagination`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setCourses(response.data.data); // Update to your API structure
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchTutors = async () => {
    if (!selectedDepartment) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const tutorResponse = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-tutor-bydept/${selectedDepartment}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setTutors(tutorResponse.data.data); // Update to your API structure
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchdepartment = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartments(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(loading) return; // Prevent multiple submissions
    setLoading(true); // Start loading state
    try {
      // const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
      }

      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-assigncourse`,
        {
          selectedDepartment,
          selectedCourseCategory,
          selectedCourse,
          selectedTutor,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // // console.log("response   ::", response);

      if (response.status && response.status === 201) {
        // alert("Mobile number should be in numbers.");
        setSnackbarMessage("Created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/assigncourse-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);
      if (err.response.status === 401) {
        setSnackbarMessage("This tutor is already assigned to the selected course.");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else if(err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields..");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      } else {
        console.error("Error creating student:", err);
        setSnackbarMessage("Failed to create. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } 
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={(e)=>handleSubmit(e)}>
              {/* Department Selection */}
              <div className="mb-20">
                <label
                  htmlFor="department"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department
                  <span className="text-danger-600">*</span>
                </label>
                <select
                required
                  className="form-control radius-8 form-select"
                  id="department"
                  value={selectedDepartment || ""}
                  onChange={(e) => {
                    setSelectedCourse("");
                    setSelectedCourseCategory("");
                    setSelectedTutor("");
                    setSelectedDepartment(e.target.value || "")
                  }}
                >
                  <option value="" disabled>
                    Select a Department
                  </option>
                  {departments.map((department) => (
                    <option key={department?._id} value={department?._id}>
                      {department?.department_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Course Category Selection */}
              <div className="mb-20">
                <label
                  htmlFor="courseCategory"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Level
                  <span className="text-danger-600">*</span>
                </label>
                <select
                required
                  className="form-control radius-8 form-select"
                  id="courseCategory"
                  value={selectedCourseCategory || ""}
                  onChange={(e) =>
                    setSelectedCourseCategory(e.target.value || "")
                  }
                >
                  <option value="" disabled>
                    Select a Level
                  </option>
                  {courseCategories.length > 0 ? (
                    courseCategories.map((courseCategory) => (
                      <option
                        key={courseCategory._id}
                        value={courseCategory._id}
                      >
                        {courseCategory?.courseCategoryName}
                      </option>
                    ))
                  ) : (
                    <option value="">No Levels Available</option>
                  )}
                </select>
              </div>

              {/* Tutor Selection */}
              <div className="mb-20">
                <label
                  htmlFor="tutor"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Select Tutor
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="tutor"
                  required
                  value={selectedTutor || ""}
                  onChange={(e) => setSelectedTutor(e.target.value || "")}
                >
                  <option value="" disabled>
                    Select Tutor
                  </option>
                  {tutors.length > 0 ? (
                    tutors.map((tutor) => (
                      <option key={tutor._id} value={tutor._id}>
                        {tutor?.name}
                      </option>
                    ))
                  ) : (
                    <option value="">No Tutors Available</option>
                  )}
                </select>
              </div>

              {/* Course Selection Radio Buttons */}
              <div className="mb-20">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                  Select Course<span className="text-danger-600">*</span>
                </label>
                <div>
                  {courses.map((course) => (
                    <div key={course?._id} className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        required
                        id={`course-${course?._id}`}
                        name="selectedCourse"
                        value={course?._id}
                        
                        checked={selectedCourse === course?._id}
                        onChange={(e) =>
                          setSelectedCourse(e.target.value || "")
                        }
                      />
                      <label
                        htmlFor={`course-${course?._id}`}
                        className="form-check-label"
                      >
                        {course?.coursename}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/assigncourse-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  // onClick={handleSubmit}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddAssignCourse;
